import React from "react";
import Typewriter from "typewriter-effect";
import videobg from "../videos/home.mp4";

const Home = ({ classicHeader, darkTheme, handleNavClick }) => {
  return (
    <section id="home">
      <div className="hero-wrap">
        <div className="hero-mask opacity-8 bg-dark" />

        <div
          className="hero-bg parallax hero-bg-mobile-fix"
          style={{ 
            backgroundImage: 'url("/images/fachu-dev-desktop-3000-flip.jpg")',
            filter: 'blur(8px)'
          }}
        ></div>

        {/* <div className="player hero-bg parallax">
          <video
            src={videobg}
            autoPlay
            muted
            loop
            style={{ width: "100%", height: "100vh", objectFit: "cover" }}
          ></video>
        </div> */}

        <div className="hero-content section d-flex min-vh-100">
          <div className="container my-auto">
            <div className="row">
              <div className="col-12 text-center">
                <p className="text-7 fw-500 text-white mb-2 mb-md-3">Hey there! =) I'm Fachu...</p>
                <h2 className="text-16 fw-600 text-white mb-2 mb-md-3">
                  <Typewriter
                    options={{
                      strings: [
                        "Tech Consultant",
                        "Website Entusiast",
                        "WordPress Expert",
                        "Hosting Manager",
                      ],
                      autoStart: true,
                      loop: true,
                      delay: 42,
                      deleteSpeed: 35,
                      pauseFor: 3000,
                    }}
                  />
                </h2>
                <p className="text-5 text-light mb-4">
                  based in Buenos Aires 🇦🇷
                </p>
                <a
                  href="#contact"
                  className="btn btn-outline-primary rounded-pill shadow-none smooth-scroll mt-2"
                  onClick={(e) => {
                    e.preventDefault();
                    handleNavClick("contact");
                  }}
                >
                  Contact Me
                </a>
              </div>
            </div>
          </div>
          <a
            href="#sectors"
            className="scroll-down-arrow text-white smooth-scroll"
            onClick={(e) => {
              e.preventDefault();
              handleNavClick("sectors");
            }}
          >
            <span className="animated">
              <i className="fa fa-chevron-down" />
            </span>
          </a>
        </div>
      </div>
    </section>
  );
};

export default Home;
